import { AssetInfoModel } from "@phdsoft/common";

export class ASSET_DEFAULTS {
  public static POINT_MAPPING_DISTANCE_MM = 1000;
  public static POINT_MAPPING_TOLERANCE_DISTANCE_MM = 1000;

  public static getPointMappingDistanceMm(): number {
    return this.POINT_MAPPING_DISTANCE_MM;
  }

  public static getPointMappingToleranceDistanceMm(): number {
    return this.POINT_MAPPING_TOLERANCE_DISTANCE_MM;
  }

  public static getPointMappingDistanceMmOrDefault(assetInfo: AssetInfoModel): number {
    if (!assetInfo.pointMappingDistanceMm || assetInfo.pointMappingDistanceMm === 0) {
      return this.POINT_MAPPING_DISTANCE_MM;
    }

    return assetInfo.pointMappingDistanceMm;
  }

  public static getPointMappingToleranceDistanceMmOrDefault(assetInfo: AssetInfoModel): number {
    if (!assetInfo.pointMappingToleranceDistanceMm || assetInfo.pointMappingToleranceDistanceMm === 0) {
      return this.POINT_MAPPING_TOLERANCE_DISTANCE_MM;
    }

    return assetInfo.pointMappingToleranceDistanceMm;
  }
} 